import site from '../content/site.json';

export const KC_TOPIC_BASE = site.paths.topicBase;
export const KC_ARTICLE_BASE = site.paths.articleBase;
export const KC_GUIDE_BASE = site.paths.guideBase || '/knowledge-center/guides';
export const KC_EBOOK_BASE = site.paths.ebookBase || '/knowledge-center/ebooks';
export const KC_DICTIONARY_BASE =
  site.paths.dictionaryBase || '/knowledge-center/dictionary';
export const KC_FAQS_PATH = site.paths.faqs;
export const KC_SEARCH_PATH = site.paths.search;
export const KC_HOME_PATH = site.paths.home;

export const DEFAULT_EBOOK_SLUG =
  site.featuredEbook?.slug || 'executive-guide-to-document-intelligence';

export function topicPath(categoryId) {
  return `${KC_TOPIC_BASE}/${categoryId}`;
}

export function articlePath(slug) {
  return `${KC_ARTICLE_BASE}/${slug}`;
}

export function guidePath(slug) {
  return `${KC_GUIDE_BASE}/${slug}`;
}

export function ebookPath(bookSlug = DEFAULT_EBOOK_SLUG) {
  return `${KC_EBOOK_BASE}/${bookSlug}`;
}

export function ebookChapterPath(bookSlug, chapterSlug) {
  return `${KC_EBOOK_BASE}/${bookSlug}/${chapterSlug}`;
}

export function formatReadTime(minutes) {
  if (!Number.isFinite(minutes)) return 'Read';
  return `${minutes} min read`;
}
